export type RichTextSegment = {
	text: string;
	bold: boolean;
};

const BOLD_PATTERN = /<strong>([\s\S]*?)<\/strong>/g;

/**
 * Splits copy that emphasises one fragment into parts a nested `Text` can render, so a translation
 * can stay one whole sentence instead of a prefix and a suffix around the bold bit.
 */
export function boldSegments(text: string): RichTextSegment[] {
	const segments: RichTextSegment[] = [];
	let cursor = 0;

	for (const match of text.matchAll(BOLD_PATTERN)) {
		const start = match.index;

		if (start > cursor) {
			segments.push({ text: text.slice(cursor, start), bold: false });
		}

		if (match[1]) {
			segments.push({ text: match[1], bold: true });
		}

		cursor = start + match[0].length;
	}

	if (cursor < text.length) {
		segments.push({ text: text.slice(cursor), bold: false });
	}

	return segments;
}
